"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extAsset2dec = exports.dec2extAsset = exports.extAsset2asset = exports.asset2extAsset = exports.dec2asset = exports.asset2dec = exports.decomposeAsset = exports.formatAsset = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const format_1 = require("./utils/format");
/**
 * Example:
 * { amount: 1230000, symbol: { symbolCode: 'DAPP', precision: 4 }} => '123.0000 DAPP'
 */
function formatAsset({ amount, symbol }, formatOptions) {
    const options = Object.assign({ withSymbol: true, separateThousands: false }, (formatOptions || {}));
    const { precision, code } = symbol;
    // amount is supposed to be an uint64, so cut off any decimals
    let s = (amount instanceof bignumber_js_1.default ? amount.toString() : String(amount)).split(`.`)[0];
    const sign = /-/i.test(s) ? -1 : 1;
    if (sign === -1) {
        s = s.replace(/-/gi, ``);
    }
    while (s.length < precision + 1) {
        s = `0${s}`;
    }
    let pre = s.slice(0, precision === 0 ? undefined : -precision);
    const decimals = precision === 0 ? `` : s.slice(-precision);
    if (options.separateThousands) {
        // adds `,` thousand separators
        // https://stackoverflow.com/a/2901298/9843487
        pre = format_1.separateThousands(pre);
    }
    let result = pre;
    if (decimals)
        result = `${result}.${decimals}`;
    if (options.withSymbol)
        result = `${result} ${code}`;
    if (sign === -1)
        result = `-${result}`;
    return result;
}
exports.formatAsset = formatAsset;
/**
 * Example
 * '123.0000 DAPP' => { amount: 1230000, symbol: { symbolCode: 'DAPP', precision: 4 }}
 */
function decomposeAsset(assetString) {
    try {
        const [amountWithPrecision, symbolName] = assetString.split(` `);
        if (!amountWithPrecision || !symbolName) {
            throw new Error(`Invalid split`);
        }
        const dotIndex = amountWithPrecision.indexOf(`.`);
        let precision = 0;
        if (dotIndex !== -1) {
            precision = amountWithPrecision.length - dotIndex - 1;
        }
        const amountNoPrecision = new bignumber_js_1.default(amountWithPrecision.replace(`.`, ``), 10);
        return {
            amount: amountNoPrecision,
            symbol: {
                precision,
                code: symbolName,
            },
        };
    }
    catch (error) {
        throw new Error(`Invalid asset passed to decomposeAsset: ${JSON.stringify(assetString)}. ${error.message}`);
    }
}
exports.decomposeAsset = decomposeAsset;
exports.asset2dec = (quantity) => {
    return quantity.amount.div(new bignumber_js_1.default(`10`).pow(quantity.symbol.precision)).toNumber();
};
exports.dec2asset = (val, symbol) => {
    const amount = new bignumber_js_1.default(val).times(new bignumber_js_1.default(`10`).pow(symbol.precision));
    return {
        amount,
        symbol,
    };
};
exports.asset2extAsset = (asset, contract) => {
    return {
        amount: asset.amount,
        extSymbol: {
            symbol: asset.symbol,
            contract,
        },
    };
};
exports.extAsset2asset = (extAsset) => {
    return {
        amount: extAsset.amount,
        symbol: extAsset.extSymbol.symbol,
    };
};
exports.dec2extAsset = (val, extSymbol) => {
    return exports.asset2extAsset(exports.dec2asset(val, extSymbol.symbol), extSymbol.contract);
};
exports.extAsset2dec = (extAsset) => {
    return exports.asset2dec(exports.extAsset2asset(extAsset));
};
// useless converters
// export const symbol2extSymbol = (symbol: TAssetSymbol, contract: string): TExtendedSymbol => {
//   return {
//     symbol,
//     contract,
//   };
// };
// export const extSymbol2symbol = (extAsset: TExtendedSymbol): TAssetSymbol => {
//   return extAsset.symbol;
// };
